import { render, staticRenderFns } from "./WizardSattvaLocationStep.vue?vue&type=template&id=042ae11f&scoped=true&"
import script from "./WizardSattvaLocationStep.vue?vue&type=script&lang=js&"
export * from "./WizardSattvaLocationStep.vue?vue&type=script&lang=js&"
import style0 from "./wizard-step-shared.css?vue&type=style&index=0&lang=css&"
import style1 from "./WizardSattvaLocationStep.vue?vue&type=style&index=1&id=042ae11f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ae11f",
  null
  
)

export default component.exports